export enum AccountsDataKeys {
  LicenseID = 'license_id',
  CreatorName = 'creator_name',
  CreatorEmail = 'creator_email',
  CompanyName = 'company.name',
  UserSlotsUsed = 'user_slots_used',
  ProjectSlotsUsed = 'project_slots_used',
  KeywordSlotsUsed = 'keyword_slots_used',
  CreatedAt = 'created_at',
}